import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { MaterialModule } from 'src/app/modules/material/material.module';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-snackbar',
  imports: [
    CommonModule,
    ToastModule,
    MaterialModule,
  ],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.css',
})
export class SnackbarComponent {

  private message = inject(SnackbarService);

  closeAlert () {
    this.message.clearSnackbar();
  }
}
